import { Maximize2, Minimize2, X } from 'lucide-react'
interface PanelToolbarProps {
  title: string
  icon?: React.ReactNode
  isMaximized?: boolean
  onMaximize?: () => void
  onClose?: () => void
  closeable?: boolean
  extra?: React.ReactNode
  leftExtra?: React.ReactNode
}

export default function PanelToolbar({
  title,
  icon,
  isMaximized,
  onMaximize,
  onClose,
  closeable = true,
  extra,
  leftExtra,
}: PanelToolbarProps) {
  return (
    <div className="flex items-center justify-between px-3 py-2 bg-background border-b border-border h-10 flex-shrink-0">
      <div className="flex items-center gap-2 min-w-0">
        {icon && <span className="text-muted-foreground flex-shrink-0">{icon}</span>}
        <span className="text-sm font-medium truncate">{title}</span>
        {leftExtra && (
          <div className="flex items-center gap-1 text-xs text-muted-foreground flex-shrink-0">
            {leftExtra}
          </div>
        )}
      </div>
      {/* min-w-0 lets crowded extras (Claude panel model/mode pickers on
          phones) truncate instead of overflowing off-screen. */}
      <div className="flex items-center gap-1 min-w-0">
        {extra}
        {onMaximize && (
          
            <button title={isMaximized ? "Restore panel to original size" : "Maximize this panel to full width"}
              onClick={onMaximize}
              className="p-1 rounded hover:bg-background transition-colors"
            >
              {isMaximized ? (
                <Minimize2 className="w-3.5 h-3.5" />
              ) : (
                <Maximize2 className="w-3.5 h-3.5" />
              )}
            </button>
          
        )}
        {closeable && onClose && (
          
            <button title="Close this panel"
              onClick={onClose}
              className="p-1 rounded hover:bg-destructive/20 hover:text-destructive transition-colors"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          
        )}
      </div>
    </div>
  )
}
